<template>
    <div class="ReLeadTableMyObj"
		v-loading.fullscreen.lock="$GVO.fullscreenLoading"
		element-loading-text="Загрузка данных..."
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)"	
		>
		<card>
		<!-- <div class="d-flex justify-content-between">
			<h4 class="mr-2">История подачи в рекламу</h4>
			<el-tooltip content="Обновить историю" placement="top"><button type="button" class="btn my-0 btn-icon btn-fab btn-primary btn-simple" @click="getApiData()"><i class="d-inline-block tim-icons icon-refresh-02"></i></button>
			</el-tooltip>
		</div> -->

		<el-table 
		ref="multipleTable"
		:data="objData" 
		style="width: 100%"
		:row-key="row => row.id"
		>	

			<el-table-column
			label="id"
			min-width="120"
			prop="id">
				<template v-slot="scope">
					<router-link :to="'/data/module/mo/object/'+scope.row.id">Объект ID {{scope.row.id}}</router-link>
				</template>
			</el-table-column>

			<el-table-column
			label="Реклама"
			min-width="100"
			prop="export_sites_count">
				<template v-slot="scope">
					<p v-if="scope.row.export_sites_count != 'undefined' && scope.row.export_sites_count > 0">Подается</p>
					<p v-else class="text-danger">Снято</p>
				</template>
			</el-table-column>

			<el-table-column
			label="Тип объекта"
			min-width="100"
			prop="objectType">
			</el-table-column>

			<el-table-column
			label="Комнат"
			min-width="70"
			prop="roomsCountTotal">
				<template v-slot="scope">
					<template v-if="scope.row.objectType=='Комната'">
						{{ scope.row.roomsCount }} из {{ scope.row.roomsCountTotal }} 
					</template>
					<template v-else>
						{{ scope.row.roomsCountTotal }} 
					</template>
					
				</template>
			</el-table-column>

			<el-table-column
				label="Адрес"
				min-width="420"
				prop="MapAddress"
			>
				<template v-slot="scope">
					<template v-if="scope.row.MapAddress.address.inputText && scope.row.MapAddress.address.inputText!=''">
						{{ scope.row.MapAddress.address.inputText }} 
					</template>
					<template v-if="scope.row.address && scope.row.address!=''">
						{{ scope.row.address }} 
					</template>
				</template>
			</el-table-column>
			<el-table-column
				label="Ответственный"
				min-width="200"
				prop="service_agent_id"
			>
				<template v-slot="scope">
					<!--a :href="'/data/staff/id/'+scope.row.agent_id">{{scope.row.agent_fio}}</!--a-->
					{{scope.row.agent_fio}}
				</template>
				
			</el-table-column>

			<el-table-column
				label="S общая, м2"
				min-width="120"
				prop="square">
			</el-table-column>


			<el-table-column
				width="140"
				sortable
				:sort-method="sortPrice"
				label="ЦЕНА"
				prop="price"
				>
				<template v-slot="scope">
					<div>{{$GVO.number_format(scope.row.price,0,'.',' ')}} ₽</div>
				</template>
			</el-table-column>

			<!-- <el-table-column
				label="Ответственный"
				sortable
				min-width="200"
				prop="service_agent_id"
				>
					<template slot-scope="scope">
					<ReInputSearchDrop
					findId="agent_id"
					placeholder="Выбрать ответсвенного"
					:value="{'inputText':scope.row.service_agent_fio,'selectedVal':scope.row.service_agent_id}"
					:objApiMethod="{'obj':'staff' ,'flt':{'fio':''}}"
					strApiMethodKey="fio"
					@change="onAgentChange($event, scope.row)"
					/>
					</template>
			</el-table-column>

			<el-table-column
				width="160"
				label="Действие"
				align="right"
			>
				<template slot-scope="scope">			
					<el-tooltip content="Сохранить изменения" placement="top">
						<el-button class="no-border my-0">
							<button class="ml-3 btn btn-icon btn-simple btn-success">
								<i class="tim-icons icon-book-bookmark"></i>
							</button>											
						</el-button>
					</el-tooltip>		
				</template>
			</el-table-column> -->

		</el-table>
	</card>
    </div>
</template>
<script>

// import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
// import { BaseRadio } from 'src/components/index';
// import Pagination from 'src/our_components/RePagination';
// import ReInputSearchDrop from "src/our_components/ReInputSearchDrop.vue";
// import Vue from 'vue';

export default {
	name: 'ReLeadTableMyObj',
	components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
    // Pagination,
    // BaseRadio,
	// ReInputSearchDrop,
	},
	data() {
		return {

		};
	},
	props: {
		objData: [Object, Array],
		// masObjects_total: [String, Number],
		objId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: [String, Number],
			default: '',
		},
	},
	computed: {
		
	},
	watch:{
		
	},
	methods: {
		sortPrice(a,b){
			return parseInt(a.price) - parseInt(b.price);
		},	
		onAgentChange(evt,row){
			//console.log(evt,row);
			row.service_agent_id = evt.selectedVal;
			row.service_agent_fio = evt.inputText;
		},

	},		
	created(){
	},
	mounted(){
	}
};
</script>
<style scoped>

/* .ReLeadTableMyObj {border: 1px solid #01b0e0; padding: 20px 5px 0px 15px; border-radius: 6px;} */
/* .card-wrapper {width: 100%; }
.card-wrapper-center {
    justify-content: center;
    margin: 0 auto;
    display: flex;
	max-width: 3000px;
} */
.ReLeadTableMyObj >>> .el-table tr:hover {cursor: pointer; background: rgb(1, 176, 224, 0.33);}
/* .ReLeadTableMyObj >>>  .el-table table {width: 100%!important;} */
.ReLeadTableMyObj >>>  .el-table .cell {word-break: break-word; }
.ReLeadTableMyObj >>> .white-content .card:not(.card-white) .el-table .cell {color: #222a42!important;}

.ReLeadTableMyObj {position: relative;}
.btn-sticky {
	position: sticky;
    top: 0px;
    z-index: 2;
	background-color: #27293d;
	display: flex;
    justify-content: center;
	border-bottom: 1px solid #01B0E0;
}

.white-content .card:not(.card-white) .btn-sticky {
	background: #fff;
}

.white-content .card:not(.card-white) >>> .table td, 	.white-content .card:not(.card-white) >>> .el-table td,
.white-content .card:not(.card-white) >>> .table th, 	.white-content .card:not(.card-white) >>> .el-table th {
    color: #222a42!important;
}

</style>
